module.exports = __webpack_public_path__ + "img/icon-warning.03fbc3f.svg";